<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
      </div>

      <app-main />
    </div>
    <setName></setName>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapGetters } from 'vuex';
import commonFn from '@/assets/javascripts/common_function.js';

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    setName: () => import('@/components/operation-guide/set-name.vue'),
  },
  mixins: [ResizeMixin],
  data() {
    return {
      isHideMenu: false,
      // 下线横条公告
      announcementVisible: false,
    };
  },
  computed: {
    ...mapGetters(['sellerId']),
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
        isHideMenu: this.isHideMenu,
      };
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(val, oldVal) {
        // hide bar
        this.isHideMenu = val.meta && val.meta.hiddenMenu;
      },
    },
  },
  created() {
    this.initAnnouncement();
    this.initAnnouncementConfirm();
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    },
    // 过滤不显示的页面
    filterShowPage() {
      const route = ['shop-detail'];
      return !route.includes(this.$route.name);
    },
    // 下线弹窗公告localStorage key
    sellerAnnouncementKey() {
      return `closeAnnouncementConfirm_${this.sellerId}`;
    },
    // 获取下线弹窗公告状态
    initAnnouncementConfirm() {
      const closeAnnouncementConfirm = localStorage.getItem(
        this.sellerAnnouncementKey()
      );
      closeAnnouncementConfirm !== '1' && commonFn.getCookie('fsellerId') != 11
    },
    // 关闭弹窗公告
    closeAnnouncementConfirm() {
      localStorage.setItem(this.sellerAnnouncementKey(), '1');
    },
    toNewBusiness() {
      this.$http
        .post('/business/account/getSellerToken', {})
        .then(res => {
          const data = res.data.data;
          if (data.sellerToken) {
            window.location.href = `https://store.linkiebuy.com?sellerToken=${data.sellerToken}`;
          } else {
            window.location.href = 'https://store.linkiebuy.com/login';
          }
        })
        .catch(() => {
          window.location.href = 'https://store.linkiebuy.com/login';
        });
    },

    // 获取下线横条公告状态
    initAnnouncement() {
      const closeAnnouncement = sessionStorage.getItem('closeAnnouncement');
      this.announcementVisible = (closeAnnouncement !== '1' && commonFn.getCookie('fsellerId') != 11);
    },
    // 关闭横条公告
    closeUpdateAnnouncement() {
      this.announcementVisible = false;
      sessionStorage.setItem('closeAnnouncement', '1');
    },
    onClickCloseAnnouncement() {
      this.closeUpdateAnnouncement();
    },
    onClickToNew() {
      this.toNewBusiness();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
.isHideMenu {
  .main-container {
    margin-left: 0 !important;
  }
  .sidebar-container,
  .navbar {
    display: none;
  }
}
.update-announcement {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 998;
  ::v-deep {
    .el-alert__content {
      flex: 1;
    }
    .el-alert {
      padding: 4px 16px;
    }
    .el-alert__description {
      margin: 0;
    }
  }
  .announcement-content {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
  }
  .btn-wrapper {
    padding-left: 10px;
  }
}
</style>
